import { render, staticRenderFns } from "./superLogin.vue?vue&type=template&id=12436913&"
import script from "./superLogin.vue?vue&type=script&lang=js&"
export * from "./superLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports